import React from 'react';
import { MessageBox } from 'components';
import { EmptyTableMessageProps } from './types';

const EmptyTableMessage = ({ tableTerms, component, title, tagline }: EmptyTableMessageProps) => {
  const { tableName = '', pluralColumnName = '', columnName = '' } = tableTerms;
  const beginsWithVowel = /^[aeiou]/i.test(columnName);
  return (
    <MessageBox
      title={title ?? `The ${tableName} has no ${pluralColumnName}`}
      tagline={tagline ?? `Please add a${beginsWithVowel ? 'n' : ''} ${columnName.toLowerCase()} to continue`}
      fullWidth={false}
      action={component}
    />
  );
};

export default EmptyTableMessage;
